
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SystemeEtats } from './etats';
import './styles/index.css';
import './styles/admin-global.css';
import './styles/systeme.css';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <BrowserRouter>
      {/* Le système d'états : toasts, confirmations, réseau, session expirée,
          erreur d'affichage, trait de navigation. Voir `src/etats/`. */}
      <SystemeEtats cheminConnexion="/login" avecIncident={false}
                    clesSession={['asso_admin_user', 'asso_admin_last_activity', 'asso_acc_token', 'asso_acc_refresh']}>
        <App />
      </SystemeEtats>
    </BrowserRouter>
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

